"use client";

// import dynamic from 'next/dynamic';
// import Ruffle from '@ruffle-rs/ruffle';
import { useEffect, useRef, useState } from "react";
import Script from "next/script";
import SvgIcons from "@/components/SvgIcons";
import './FlashContentDisplay.css';

declare global {
    interface Window {
        RufflePlayer?: any;
    }
}

export interface FlashContentDisplayProps {
    src: string;
    title: string;
    home?: boolean | null;
    footer?: string | null;
};

const { FullScreenIcon, FullScreenExitIcon } = SvgIcons();

function FlashContentDisplay({ src, title, home, footer }: FlashContentDisplayProps) {
    const [boardWidth, setBoardWidth] = useState(550);

    const [fullscreenMode, setFullscreenMode] = useState<boolean>(false);
    const gameWindowContainer = useRef<HTMLDivElement | null>(null);
    const boardElement = useRef<HTMLDivElement | null>(null);
    const intervalHandlerResize = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const handleWindowResize = () => {
            if (boardElement) {
                if (boardElement && boardElement.current) {
                    intervalHandlerResize.current = setInterval(() => { handleWindowScroll() }, 50);
                    setTimeout(() => {
                        if (intervalHandlerResize.current) {
                            clearInterval(intervalHandlerResize.current)
                        }
                    }, 800);
                }
            }
        }

        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('scroll', handleWindowScroll);

        setTimeout(() => { handleWindowScroll() }, 50);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('scroll', handleWindowScroll);
            if (intervalHandlerResize.current) {
                clearInterval(intervalHandlerResize.current);
            }
        };
    }, []);

    useEffect(() => {
        if (fullscreenMode) {
            gameWindowContainer.current?.requestFullscreen();
        } else if (document.fullscreenElement !== null && document.fullscreenElement === gameWindowContainer.current) {
            document.exitFullscreen();
        }
    }, [fullscreenMode]);

    const handleWindowScroll = () => {
        if (boardElement && boardElement.current) {
            setBoardWidth(boardElement.current.clientWidth);
        }
    }

    return (
        <div className={`gameContainer gameContainerFlash ${home ? 'home' : ''} ${fullscreenMode ? 'fullScreenMode' : ''}`} ref={gameWindowContainer} >
            <div className="gameTitle" style={{ width: boardWidth, margin: '0 auto' }}><h1>{title}</h1></div>
            <div ref={boardElement} className="gameBoardContainer" style={{ margin: '0 auto' }}>
                <object id="gamePlayer" style={{ width: '100%', height: '100%', borderRadius: 8 }}>
                    <embed src={src} style={{ width: '100%', height: '100%', borderRadius: 8  }} />
                </object>
                <button className='absolute right-2 bottom-1' onClick={() => setFullscreenMode((fullscreenMode) => !fullscreenMode) }>
                    {!fullscreenMode && <FullScreenIcon width='20px' height='16px' color='#123' />}
                    {fullscreenMode && <FullScreenExitIcon width='20px' height='16px' color='#123' />}
                </button>
            </div>
            <div className="startButton" style={{ width: boardWidth }}>
                {footer && (<div dangerouslySetInnerHTML={{ __html: footer }} />)}
            </div>
            <Script
                src="https://unpkg.com/@ruffle-rs/ruffle"
                strategy="afterInteractive"
                onLoad={() => {
                    window.RufflePlayer = window.RufflePlayer || {};
                    window.RufflePlayer.config = {
                        autoplay: "on",
                        unmuteOverlay: "visible",
                        playerRuntime: "air",
                    };
                }}
            />
        </div>
    );
}

export default FlashContentDisplay;
